import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, HostListener } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject, combineLatest } from 'rxjs';
import { ChapterModel } from 'src/app/story/models/chapter.model';
import { takeUntil, filter, map, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-view-print',
  templateUrl: './view-print.component.html',
  styleUrls: ['./view-print.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewPrintComponent implements OnInit, OnDestroy {
  // ---------- Selectors ----------
  @Select(StoryChaptersState.getStoryChapters)
  storyChapters$: Observable<ChapterModel[]>;


  // ---------- Properties ----------
  ngUnsubscribe = new Subject();
  imageUrl: string;
  visible = false;
  
  
  // ---------- Host Listeners ----------
  @HostListener('window:beforeprint')
  beforePrint(event: any) {
    this.visible = true;
    this.changeDetectorRef.markForCheck();
  }

  @HostListener('window:afterprint')
  afterPrint(event: any) {
    this.visible = false;
    this.changeDetectorRef.markForCheck();
  }
  
  // ---------- Lifecycle ----------
  constructor(
    private store: Store,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.initImageUrlListener();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  
  
  // ---------- Listeners ----------
  initImageUrlListener() {
    combineLatest(
      this.storyChapters$,
      this.store.select(StoryChaptersState.getRegisteredThumbnails)
    )
    .pipe(
      filter(([chapters, thumbnails]) => chapters.length > 0 && thumbnails.size > 0),
      map(([chapters, thumbnails]) => thumbnails.get(chapters[0].id).urls.large),
      distinctUntilChanged(),
      takeUntil(this.ngUnsubscribe)
    )
    .subscribe(imageUrl => {
      this.imageUrl = imageUrl;
      this.changeDetectorRef.markForCheck();
    });
  }

}
